// Financial thunks — payments, refunds, Stripe checkout
import { dispatch, store } from '../../store';
import { updateError } from '../user';
import { callApi } from '../../../utils/apiCall';
import { getCurrentTreatmentIdV2 } from '../clincheck';
import { leadActions, startLoadingData, updateCompleteStatus } from './slice';

export function leadDetailPayment(handleClose) {
    return async () => {
        try {
            const { newLeadDetail: { payment }, leadDetail } = store.getState().lead;
            const { practiceId } = store.getState().practiceTreatmentList;
            if (payment.payment_type !== 'No') {
                dispatch(startLoadingData(true));
                dispatch(leadTreatmentPayment(practiceId, leadDetail?.id, leadDetail?.lead_treatments[0]?.id, payment, handleClose));
            } else {
                handleClose();
                dispatch(updateCompleteStatus(false));
            }
        } catch (error) {
            dispatch(updateError({ message: JSON.stringify(error.message), success: false }));
            dispatch(updateCompleteStatus(false));
        }
    };
}

export function leadTreatmentPayment(practiceId, leadId, treatmentId, data, handleClose) {
    return async () => {
        try {
            const value = {
                ...data,
                mode_of_payment: data.mode_of_payment === 'SEND' ? 'EMAIL' : data.mode_of_payment
            };
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${leadId}/treatments/${getCurrentTreatmentIdV2(treatmentId)}/payments/`, 'post', value);
            if (response?.status === 201) {
                const { newLeadDetail: { payment } } = store.getState().lead;
                if (payment.mode_of_payment === 'SEND') {
                    dispatch(paymentCheckout(practiceId, leadId, getCurrentTreatmentIdV2(treatmentId), response.data.id, handleClose));
                    return;
                }
                dispatch(updateError({ success: true, message: 'Payment detail added successfully' }));
                dispatch(updateCompleteStatus(false));
                handleClose('finish', leadId);
                dispatch(startLoadingData(false));
            } else {
                dispatch(updateError({ success: false, message: JSON.stringify(response.data) }));
                dispatch(updateCompleteStatus(false));
            }
        } catch (error) {
            dispatch(leadActions.hasError(error.message));
            dispatch(startLoadingData(false));
        }
    };
}

export function getLeadTreatmentPayment(practiceId, leadId, treatmentId) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${leadId}/treatments/${treatmentId}/payments/`);
            if (response?.status === 200) {
                dispatch(leadActions.paymentCompleteSlice(response.data.results));
            } else {
                dispatch(updateError({ message: JSON.stringify(response.data), success: false }));
            }
        } catch (error) {
            dispatch(updateError({ message: JSON.stringify(error.message) || 'Something went wrong', success: false }));
            dispatch(updateCompleteStatus(false));
        }
    };
}

export function getLeadPaymentCheckout(practiceId, leadId, treatmentId, paymentId) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${leadId}/treatments/${treatmentId}/payments/${paymentId}/checkout_sessions/`);
            if (response?.status === 200) {
                dispatch(leadActions.checkoutListingSlice(response.data));
            } else {
                dispatch(updateError({ message: JSON.stringify(response.data), success: false }));
            }
        } catch (error) {
            dispatch(updateError({ message: JSON.stringify(error.message) || 'Something went wrong', success: false }));
            dispatch(updateCompleteStatus(false));
        }
    };
}

export function getLeadRefundRequest(practiceId, leadId, treatmentId, paymentId, checkoutId) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${leadId}/treatments/${treatmentId}/payments/${paymentId}/checkout_sessions/${checkoutId}/refund_requests/`);
            if (response?.status === 200) {
                dispatch(leadActions.refundListingSlice(response.data.results));
            } else {
                dispatch(updateError({ message: JSON.stringify(response.data), success: false }));
            }
        } catch (error) {
            dispatch(updateError({ message: JSON.stringify(error.message) || 'Something went wrong', success: false }));
            dispatch(updateCompleteStatus(false));
        }
    };
}

export function createRefundRequest(data, practiceId, leadId, treatmentId, paymentId, checkoutId, handleSuccess) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${leadId}/treatments/${treatmentId}/payments/${paymentId}/checkout_sessions/${checkoutId}/refund_requests/`, 'post', data);
            if (response?.status === 201) {
                handleSuccess({ success: true, message: 'Refund added successfully' });
                dispatch(getLeadRefundRequest(practiceId, leadId, treatmentId, paymentId, checkoutId));
            } else {
                dispatch(updateError({ message: JSON.stringify(response.data), success: false }));
            }
        } catch (error) {
            dispatch(updateError({ message: JSON.stringify(error.message) || 'Something went wrong', success: false }));
            dispatch(updateCompleteStatus(false));
        }
    };
}

export function retryRefundRequest(practiceId, leadId, treatmentId, paymentId, checkoutId, id, handleSuccess) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${leadId}/treatments/${treatmentId}/payments/${paymentId}/checkout_sessions/${checkoutId}/refund_requests/${id}/retry/`, 'post');
            if (response?.status === 200) {
                handleSuccess({ success: true, message: 'Refund added successfully' });
                dispatch(getLeadRefundRequest(practiceId, leadId, treatmentId, paymentId, checkoutId));
            } else {
                dispatch(updateError({ message: JSON.stringify(response.data), success: false }));
            }
        } catch (error) {
            dispatch(updateError({ message: JSON.stringify(error.message) || 'Something went wrong', success: false }));
            dispatch(updateCompleteStatus(false));
        }
    };
}

export function paymentCheckout(practiceId, lead, treatment, paymentId, handleClose) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/${lead}/treatments/${treatment}/payments/${paymentId}/checkout_sessions/`, 'post', {});
            if (response?.status === 201) {
                dispatch(updateError({ success: true, message: 'Payment link send successfully' }));
                dispatch(updateCompleteStatus(false));
                handleClose('finish', lead);
                dispatch(startLoadingData(false));
            } else {
                dispatch(updateError({ success: false, message: response.data.message || 'Something went wrong' }));
                dispatch(updateCompleteStatus(false));
                dispatch(startLoadingData(false));
            }
        } catch (error) {
            dispatch(updateError({ success: false, message: error.message || 'Something went wrong' }));
            dispatch(startLoadingData(false));
        }
    };
}

export function createStripePayment(practiceId, data, handleSuccess) {
    return async () => {
        try {
            const response = await callApi(`/api/v1/practices/${practiceId}/checkout_sessions/`, 'post', data);
            if (response?.status === 201) {
                handleSuccess({ success: true, message: 'Stripe payment created successfully', response: response?.data });
            } else {
                dispatch(updateError({ message: JSON.stringify(response?.data), success: false }));
                document.body.classList.remove('points-event');
                handleSuccess({ success: false, message: JSON.stringify(response?.data) });
            }
        } catch (error) {
            dispatch(updateError({ message: JSON.stringify(error.message) || 'Something went wrong', success: false }));
        }
    };
}
